module.exports = __webpack_public_path__ + "media/images/vp/icon.vote.smile-3-fef4ed85610144a3f007ce4be83b5e51.svg";